import { createFileRoute } from '@tanstack/react-router'
import { ProfileSettingsPage } from '@/pages/settings/profile-settings-page'

export const Route = createFileRoute('/settings/profile')({
  component: ProfileSettingsPage,
})
